import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=ded7940c&scoped=true&"
import script from "./CustomModal.vue?vue&type=script&lang=js&"
export * from "./CustomModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=ded7940c&scoped=true&lang=css&"
import style1 from "./CustomModal.vue?vue&type=style&index=1&id=ded7940c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded7940c",
  null
  
)

export default component.exports